import "./ListOpportunities.scss";

import React from 'react';
import { connect } from "react-redux";
import { routerActions } from "react-router-redux";
import update from 'immutability-helper';

import { handleTextChange } from 'utils/handle-changes';

import {
    clearOpportunity, clearSearchOpportunities, emptyOpportunities, getSearchForOpportunities, setOpportunity, setOpportunitiesFilters,
    setOpportunitiesSearchField
} from 'containers/Opportunities/store/actions';
import { getAllIndustryExperienceTypes, getAllSpecialties } from 'containers/App/store/actions';

import Button from 'components/Button';
import Checkbox from 'components/Checkbox';
import Form from 'components/Form';
import FormRow from 'components/FormRow'
import H1 from 'components/H1';
import H2 from 'components/H2';
import H3 from 'components/H3';
import Icon from 'components/Icon';
import LoadingCircle from "components/LoadingCircle";
import MessageModal from 'components/Modal/MessageModal';
import OpportunityResult from "containers/Opportunities/components/OpportunityResult";
import PageContent from "components/PageContent";
import TextArea from 'components/Textbox';

class ListOpportunities extends React.Component {
    constructor() {
        super();

        this.state = {
            currentTerm: "",
            showResultsSummary: false
        };
    }

    componentWillMount() {
        this.props.getAllIndustryExperienceTypes();
        this.props.getAllSpecialties();

        if(this.props.location.query.searchTerm || this.props.location.query.s || this.props.location.query.e) {
            this.parseQueryString(this.props.location.query);
        }
    }

    componentWillUnmount() {
        this.props.emptyState();
    }

    componentWillReceiveProps(nextProps) {
        let oldQuery = this.props.location.query;
        let newQuery = nextProps.location.query;

        if(oldQuery.searchTerm !== newQuery.searchTerm || oldQuery.s !== newQuery.s || oldQuery.e !== newQuery.e) {
            this.parseQueryString(newQuery);
        }
    }

    _openCloseFilterList(event) {
        let target = event.target;
        while(target.getAttribute('class') == null || target.getAttribute('class').indexOf('filtersection') === -1) {
            target = target.parentNode;
        }

        target.querySelector('.filtersection-options').style.height = target.querySelector('.filtersection-options--inner').offsetHeight + 'px';
        if(target.classList.contains('filtersection--closed') === false) {
            setTimeout(() => {
                target.querySelector('.filtersection-options').style.height = '84px';
            }, 5)
        }
        target.classList.toggle('filtersection--closed');
    }

    parseQueryString(querystring) {
        let searchTerm = querystring.searchTerm || '';
        let filters = {
            experienceIds: querystring.e ? querystring.e.split(',').map((e) => parseInt(e, 10)) : [],
            specializationIds: querystring.s ? querystring.s.split(',').map((e) => parseInt(e, 10)) : []
        };

        this.props.setSearchField(searchTerm);
        this.props.setOpportunitiesFilters(filters);

        setTimeout(() => {
            this.performSearch();
        }, 100);
    }

    performSearch = (event) => {
        if(event) {
            event.preventDefault();
        }

        this.props.searchForOpportunities(this.props.searchTerm);
        this.setState({
            currentTerm: this.props.searchTerm,
            showResultsSummary: true
        });
        this.props.changeLocation(`/opportunities?searchTerm${this.props.searchTerm ? `=${encodeURIComponent(this.props.searchTerm)}` : ''}${this.props.opportunities.filters.experienceIds.length > 0 ? `&e=${this.props.opportunities.filters.experienceIds.join(',')}` : ''}${this.props.opportunities.filters.specializationIds.length > 0 ? `&s=${this.props.opportunities.filters.specializationIds.join(',')}` : ''}`)
    };

    _handleChange = (name, value) => {
        this.props.setSearchField(value);
    };

    _handleFilterChange(filterName, filterId) {

        let newFiltersObj = update(this.props.opportunities.filters, {});
        if(newFiltersObj[filterName].indexOf(filterId) === -1) {
            newFiltersObj[filterName].push(filterId);
        } else {
            newFiltersObj[filterName].splice(newFiltersObj[filterName].indexOf(filterId), 1);
        }

        this.props.setOpportunitiesFilters(newFiltersObj);
        this.performSearch();
    };

    render() {
        return (
            <span>
                <div className="heroheader">
                    <H1>Search for Opportunities</H1>
                    <Form className="opportunities-search">
                        <FormRow>
                            <TextArea
                                name="opportunitiessearch"
                                type="text"
                                value={this.props.searchTerm}
                                icon="search"
                                onChange={(event) => handleTextChange(this._handleChange, event)}
                            />
                            <Button type="submit" onSubmit={this.performSearch} onClick={this.performSearch}>Search</Button>
                        </FormRow>
                    </Form>
                </div>
                <PageContent className="list-opportunities">
                    <div className="opportunitiescolumn opportunitiescolumn-left">
                        <H2><Icon type="options" /> Filters</H2>

                        <div className="filtersection filtersection--closed">
                            <H3 onClick={this._openCloseFilterList.bind(this)} role="button">
                                Specialty <Icon type="plus" /> <Icon type="minus" />
                            </H3>
                            <div className="filtersection-options">
                                <div className="filtersection-options--inner">
                                    {this.props.app.specialties.map((specialty) => (
                                        <Checkbox
                                            checked={this.props.opportunities.filters.specializationIds.indexOf(specialty.id) !== -1}
                                            id={`chkSpecialty${specialty.id}`}
                                            key={specialty.id}
                                            label={specialty.name}
                                            name={`specialty${specialty.id}`}
                                            onChange={this._handleFilterChange.bind(this, 'specializationIds', specialty.id)}
                                        />
                                    ))}
                                </div>
                            </div>
                        </div>

                        <div className="filtersection filtersection--closed">
                            <H3 onClick={this._openCloseFilterList.bind(this)} role="button">
                                Industry Experience <Icon type="plus" /> <Icon type="minus" />
                            </H3>
                            <div className="filtersection-options">
                                <div className="filtersection-options--inner">
                                    {this.props.app.industryExperienceTypes.map((type) => (
                                        <Checkbox
                                            checked={this.props.opportunities.filters.experienceIds.indexOf(type.id) !== -1}
                                            id={`chkIndustryExperienceType${type.id}`}
                                            key={type.id}
                                            label={type.name}
                                            name={`type${type.id}`}
                                            onChange={this._handleFilterChange.bind(this, 'experienceIds', type.id)}
                                        />
                                    ))}
                                </div>
                            </div>
                        </div>

                        {/*<div className="filtersection">
                            <H3>Agency <Icon type="plus" /></H3>
                            <div className="filtersection-options"></div>
                        </div>*/}
                    </div>
                    <div className="opportunitiescolumn opportunitiescolumn-right">

                    {this.state.showResultsSummary === true ? (
                        <div className="resultscount">
                            {this.props.searchResults.length} result{this.props.searchResults.length !== 1 ? 's' : ''} {this.state.currentTerm !== '' ? `for "${this.state.currentTerm}"`: null }
                        </div>
                    ) : (
                        <div className="resultscount resultscount--presearch">
                            Use the textbox above to search for keywords, or select filters on the left to perform a search.
                        </div>
                    )}


                        <div className="opportunities-results">
                            {this.props.isFetching ?
                                <LoadingCircle />
                            : <div>
                                {this.props.searchResults.map((result) => {
                                    return (
                                        <OpportunityResult
                                            allowsRemote={result.allowsRemote}
                                            author={result.company}
                                            description={result.summary}
                                            duration={result.duration}
                                            handleMessageClick={() => {
                                                this.props.setOpportunity(result);
                                                this.messageModal.showMessageModal()
                                            }}
                                            id={result.id}
                                            key={result.id}
                                            location={result.company.location}
                                            startDate={result.startDate}
                                            title={result.title}
                                        />
                                    )
                                })}
                            </div> }
                        </div>
                        {this.props.searchResults.length > 0 ? (
                            <div className="pagecount">
                                1 - {this.props.searchResults.length} of {this.props.searchResults.length}
                            </div>
                        ) : null}
                    </div>
                </PageContent>

                <MessageModal
                    onCloseModal={() => this.props.clearOpportunity()}
                    onRef={ref => (this.messageModal = ref)}
                />
            </span>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        app: state.app,
        opportunities: state.opportunities,
        isFetching: state.opportunities.isFetching,
        searchResults: state.opportunities.searchResults,
        searchTerm: state.opportunities.searchTerm
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        changeLocation: (path) => dispatch(routerActions.push(path)),
        clearOpportunity: () => dispatch(clearOpportunity()),
        clearSearchResults: () => dispatch(clearSearchOpportunities()),
        emptyState: () => dispatch(emptyOpportunities()),
        getAllIndustryExperienceTypes: () => dispatch(getAllIndustryExperienceTypes()),
        getAllSpecialties: () => dispatch(getAllSpecialties()),
        searchForOpportunities: (searchTerm) => dispatch(getSearchForOpportunities(searchTerm)),
        setOpportunitiesFilters: (filtersObj) => dispatch(setOpportunitiesFilters(filtersObj)),
        setSearchField: (value) => dispatch(setOpportunitiesSearchField(value)),
        setOpportunity: (opportunityObj) => dispatch(setOpportunity(opportunityObj))
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(ListOpportunities);



// WEBPACK FOOTER //
// ./src/containers/Opportunities/Listing/index.js